import { render, staticRenderFns } from "./TrainingVideo.vue?vue&type=template&id=6500c66a&scoped=true"
import script from "./TrainingVideo.vue?vue&type=script&lang=js"
export * from "./TrainingVideo.vue?vue&type=script&lang=js"
import style0 from "./TrainingVideo.vue?vue&type=style&index=0&id=6500c66a&scoped=true&lang=less"
import style1 from "./TrainingVideo.vue?vue&type=style&index=1&id=6500c66a&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6500c66a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6500c66a')) {
      api.createRecord('6500c66a', component.options)
    } else {
      api.reload('6500c66a', component.options)
    }
    module.hot.accept("./TrainingVideo.vue?vue&type=template&id=6500c66a&scoped=true", function () {
      api.rerender('6500c66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/TrainingVideo.vue"
export default component.exports